import { spItemKeyFacet } from '../../dataSource/Keys';

/**
 * @internal
 */
export function getNormalizedFolderKey(itemKeyParts: typeof spItemKeyFacet.type): typeof spItemKeyFacet.type {
  return {
    ...itemKeyParts,
    itemId: ''
  };
}
